import { DataGuard } from "@components/DataGuard";
import LayoutHeader from "@components/LayoutHeader";
import Panel from "@components/Panel";
import { A } from "@solidjs/router";
import { ChevronRight } from "lucide-solid";
import { createMemo } from "solid-js";
import { useService } from "solid-services";
import { css } from "styled-system/css";
import { Box, Flex } from "styled-system/jsx";
import { GROUPS, getCourseDecor } from "../courseDecor";
import { useCourseOverview } from "../useCourseOverview";
import Content from "./Content";
import Info from "./Info";

export default function () {
  const { activeLessonOverviewQuery, courseTitle } = useService(useCourseOverview)()

  const groupLabel = createMemo(() => {
    const title = courseTitle()
    if (!title) return undefined
    return GROUPS.find((g) => g.key === getCourseDecor(title).group)?.label
  })

  return (
    <>
      <LayoutHeader
        leftContent={
          <Flex align="center" gap="8px" fontSize="12.5px" color="editorialInk3" minWidth="0">
            <A
              href="/courses"
              class={css({ color: 'inherit', textDecoration: 'none', whiteSpace: 'nowrap', '&:hover': { color: 'editorialInk' } })}
            >
              Courses
            </A>
            <ChevronRight size={14} style={{ opacity: .55, flex: 'none' }} />
            <Box whiteSpace="nowrap">{groupLabel()}</Box>
            <ChevronRight size={14} style={{ opacity: .55, flex: 'none' }} />
            <Box
              color="editorialInk2"
              fontWeight="600"
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              minWidth="0"
            >
              {courseTitle()}
            </Box>
          </Flex>
        }
      />
      <Panel
        display="block"
        height="calc(var(--vh) * 100 - 60px)"
        overflowY="auto"
      >
        <Box maxWidth="1000px" mx="auto" px={{ base: '22px', smDown: '14px' }} py={{ base: '22px', smDown: '16px' }} pb="60px">
          <DataGuard query={activeLessonOverviewQuery}>
            {() => (
              <>
                <Info />
                <Content />
              </>
            )}
          </DataGuard>
        </Box>
      </Panel>
    </>
  )
}
